





















import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    shadow: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
    tabindex: {
      type: String as PropType<string>,
      required: true,
    },
    valid: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
  },
  data: () => ({
    dropdownOpen: false,
  }),
  methods: {
    toggle(): void {
      if (this.dropdownOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    open(): void {
      this.dropdownOpen = true;
      this.$emit("opened");
    },
    close(): void {
      this.dropdownOpen = false;
      this.$emit("closed");
    },
  },
});
